import UploadRegimeProofError from './UploadRegimeProofError';
class FiscalRegimeIsInProcess extends UploadRegimeProofError {
    constructor(options) {
        super('Investor has a fiscal regime proof in process', options);
    }
}
export default FiscalRegimeIsInProcess;
